export default "/images/connect.svg?5375eb7c8ef80bd64de6f334aab1a770";